package com.eladfinish.bible.contest.screens.browse.tableOfContents.model

import androidx.compose.material3.SnackbarDuration
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.lexicographically_sorted_verses_book
import com.eladfinish.bible.contest.lexicographically_sorted_verses_by_mikud
import com.eladfinish.bible.contest.lexicographically_sorted_verses_chapter
import com.eladfinish.bible.contest.lexicographically_sorting_book
import com.eladfinish.bible.contest.lexicographically_sorting_by_mikud
import com.eladfinish.bible.contest.lexicographically_sorting_chapter
import dev.icerock.moko.resources.StringResource

enum class OutputChapters(
    val place: StringResource,
    val sentence: StringResource,
    val snackbarDuration: SnackbarDuration,
    val isPremium: Boolean,
) {
    SINGLE(
        place = SharedRes.strings.lexicographically_sorted_verses_chapter,
        sentence = SharedRes.strings.lexicographically_sorting_chapter,
        snackbarDuration = SnackbarDuration.Short,
        isPremium = false,
    ),
    BY_MIKUD(
        place = SharedRes.strings.lexicographically_sorted_verses_by_mikud,
        sentence = SharedRes.strings.lexicographically_sorting_by_mikud,
        snackbarDuration = SnackbarDuration.Long,
        isPremium = false,
    ),
    ALL(
        place = SharedRes.strings.lexicographically_sorted_verses_book,
        sentence = SharedRes.strings.lexicographically_sorting_book,
        snackbarDuration = SnackbarDuration.Long,
        isPremium = false,
    ),
}
